import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { notify } from 'reapop'

import AboutUsService from '../middlewares/aboutUs'
import {
  GET_ABOUT_US_REQUEST,
  GET_ABOUT_US,
  UPDATE_ABOUT_US_REQUEST,
  UPDATE_ABOUT_US,
  GET_ABOUT_US_REQUEST_PENDING,
  GET_ABOUT_US_REQUEST_SUCCESS,
  GET_ABOUT_US_REQUEST_ERROR,
  CHANGE_ABOUT_US_REQUEST_PENDING,
  CHANGE_ABOUT_US_REQUEST_SUCCESS,
  CHANGE_ABOUT_US_REQUEST_ERROR,
} from '../types/aboutUs'

function* getAboutUsWatcher() {
  yield takeEvery(GET_ABOUT_US_REQUEST, getAboutUsWorker)
}

function* updateAboutUsWatcher() {
  yield takeEvery(UPDATE_ABOUT_US_REQUEST, updateAboutUsWorker)
}

function* getAboutUsWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_ABOUT_US_REQUEST_PENDING })
    const response = yield call(AboutUsService.getAboutUs)
    yield put({ type: GET_ABOUT_US, payload: response.data.data || null })
    yield put({ type: GET_ABOUT_US_REQUEST_SUCCESS })
  } catch (error) {
    yield put({
      type: GET_ABOUT_US_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to fetch About Us content' }],
    })
  } finally {
    yield put(hideLoading())
  }
}

function* updateAboutUsWorker({ payload }) {
  const { data, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_ABOUT_US_REQUEST_PENDING })
    const response = yield call(AboutUsService.updateAboutUs, data || payload)
    yield put({ type: UPDATE_ABOUT_US, payload: response.data.data })
    yield put({ type: CHANGE_ABOUT_US_REQUEST_SUCCESS })
    yield put(
      notify({
        status: 'success',
        title: 'About Us saved successfully',
        dismissAfter: 3000,
      }),
    )
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, response.data.data)
    }
  } catch (error) {
    yield put({
      type: CHANGE_ABOUT_US_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to save About Us content' }],
    })
    if (typeof onError === 'function') {
      yield call(onError, error)
    }
  } finally {
    yield put(hideLoading())
  }
}

export default function* aboutUs() {
  yield all([fork(getAboutUsWatcher), fork(updateAboutUsWatcher)])
}

